import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'validacion-pago-proactivo',
  templateUrl: './validacion-pago-proactivo.html',
  styleUrls: ['./validacion-pago-proactivo.scss']
})
export class ValidacionPagoProactivoComponent implements OnInit {

  public loadingPage = true;
  public pagoExitoso : boolean;


  constructor(
    private router: Router,
    private productoVM: vmProductosService
  ) { }

  ngOnInit() {
    const urlParams = this.router.parseUrl(this.router.url);
    var run : number = urlParams.queryParams.run;
    this.productoVM.validaPagoProductoProactivo(run).subscribe(res => {
      this.loadingPage = false;
      this.pagoExitoso = res.data;
    })
  }

  redirectToMarket(){
    window.location.href= environment.redirections.marketplace;
  }
}
